import { SearchOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, DatePickerProps, Input, Row, Space, Table } from 'antd';
import Column from 'antd/es/table/Column';
import ColumnGroup from 'antd/es/table/ColumnGroup';
import dayjs, { Dayjs } from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ContentHeader } from "../../components";
import ModalTextForm from '../../components/modal/ModalTextForm';
import { idQuyDauTu, loaiLanhDaoPhuTrach, trangThaiKPI } from '../../constants';
import { Links } from '../../helpers/Links';
import { menuHelper } from '../../helpers/account';
import { dateCommon } from '../../helpers/common';
import { KPIPhongBanPagingResponse, KPIPhongBanResponse } from '../../models/kpi/KPIPhongBan';
import ContainerDonViPhuTrach from '../../modules/department/ContainerDonViPhuTrach';
import { timKiemDSKPIYKien } from '../../services/kpi';
import TabKetQuaHoanThanh from './TabKetQuaHoanThanh';
import { getXepLoai, getXepLoaiByDiemDanhGia } from './kpiHelper';
const YKienKPIPhoGiamDoc = () => {
    const dispatch = useDispatch();
    const menu: any = menuHelper.checkMultiPermission([
        Links.KPI.ChiTietKPI,
        Links.KPI.LanhDaoPhuTrachDuyet
    ]);
    const [reloadPage, setReloadPage] = useState<boolean>(true);
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);
    const [idDonVi, setIdDonVi] = useState<number>(idQuyDauTu);
    const [tuKhoa, setTuKhoa] = useState<string>("");
    let ngayHienTai = (dayjs()).date() <= 10 ? (dayjs()).subtract(1, 'month') : dayjs();
    let thangHienTai = ngayHienTai.startOf('month').format('DD/MM/YYYY HH:mm:ss'); 
    const [thangNam, setThangNam] = useState<string>(thangHienTai);
    const [ngayThang, setNgayThang] = useState<Dayjs | null>(ngayHienTai);
    const monthFormat = 'MM/YYYY';
    const thangNamFormat: DatePickerProps['format'] = (value) => `Tháng ${value.format(monthFormat)}`;
    const [data, setData] = useState<Array<KPIPhongBanResponse>>([]);
    const [danhsach, setDanhSach] = useState<KPIPhongBanPagingResponse>({
        "data": [],
        "nhanViens": []
    });
    const user = useSelector((state: any) => state.auth.currentUser);
    const onChange: DatePickerProps['onChange'] = (date) => {
        var dateStr = date?.startOf('month').format('DD/MM/YYYY HH:mm:ss');
        setNgayThang(date);
        if (dateStr) {
            setThangNam(dateStr);
            timkiem(idDonVi, tuKhoa, dateStr);
        } else {
            setThangNam("");
            timkiem(idDonVi, tuKhoa, "");
        }
    }

    const onChangeDepartment = (e: any) => {
        if (e) {
            setIdDonVi(e.id);
            timkiem(e.id, tuKhoa, thangNam);
        } else {
            setIdDonVi(0);
            setData([]);
        }
    };

    const containerDepartmentProps = {
        showHeader: false,
        onChange: onChangeDepartment,
        value: idDonVi,
        loaiPhuTrach: loaiLanhDaoPhuTrach.phuTrach2
    }

    const timkiem = async (idDonVi: number, tuKhoa: string, thangNam: string) => {
        try {
            setIsLoadingTable(true);
            const temp = await timKiemDSKPIYKien(idDonVi, tuKhoa, thangNam);
            setData((temp?.data || []).map((item: any) => {
                return { ...item, key: item.idKPICaNhan }
            }));
            setDanhSach({
                "data": (temp?.data || []).map((item: any) => {
                    return { ...item, key: item.idKPICaNhan }
                }),
                "nhanViens": (temp?.nhanViens || []).map((item: any) => {
                    return { ...item, key: item.idNhanVien }
                })
            });
            setIsLoadingTable(false);
        }
        catch (error: any) {
            setIsLoadingTable(false);
        };
    }
    

    const layClassName = (value: any) => {
        let result = "btn-primary";

        if (value.yKien != null && !(value.trangThai == trangThaiKPI.trinhLanhDaoDonVi || value.trangThai == trangThaiKPI.lanhDaoDonViTuChoi)) {
            result = "btn-success";
        }

        return result;
    }

    const [openModalChiTiet, setOpenModalChiTiet] = useState(false);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        let idDV = +(params.get('idDonVi') || '');
        if(idDV > 0){
            setIdDonVi(+idDV);
        }
        let thangNamParams = (params.get('thangNam') || '');
        var thangNamDayjs = dateCommon.convertThangNamToDayjs(thangNamParams);
        var dateStr = "";
        if (thangNamDayjs != null) {
            dateStr = thangNamDayjs?.startOf('month').format('DD/MM/YYYY HH:mm:ss');
            setNgayThang(thangNamDayjs);
            setThangNam(dateStr);
        }
        if (reloadPage) {
            setData([]);
            setDanhSach({
                "data": [],
                "nhanViens": []
            });
            timkiem(idDV > 0 ? idDV : idDonVi, tuKhoa, dateStr!= "" ? dateStr : thangNam);
            setReloadPage(false);
        }
    }, [reloadPage]);

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            timkiem(idDonVi, tuKhoa, thangNam);
        }
    };
    return (<section>
        <ContentHeader title="Ý kiến KPI" />
        <Row className="form-group" gutter={8}>
            <Col span={4}>
                <DatePicker
                    changeOnBlur={true}
                    allowClear={false}
                    value={ngayThang}
                    style={{ width: "100%" }}
                    placeholder="Tháng đánh giá"
                    picker="month"
                    format={thangNamFormat}
                    onChange={onChange} />
            </Col>
            <Col span="7">
                <ContainerDonViPhuTrach {...containerDepartmentProps} />
            </Col>
            <Col span={7}>
                <Input allowClear prefix={<SearchOutlined rev="" />} placeholder="Nhập tên, mã nhân viên" onChange={(e) => setTuKhoa(e.target.value)}
                    onKeyPress={handleKeyPress} />
            </Col>
            <Col span={3}>
                <Space>
                    <Button type="primary" icon={<SearchOutlined rev="" />} onClick={() => {
                        timkiem(idDonVi, tuKhoa, thangNam); }}>
                        Tìm kiếm
                    </Button>
                </Space>
            </Col>
        </Row>
        <Row className="form-group" gutter={8}>
            <Col span={24}>
                <TabKetQuaHoanThanh
                    danhsach={danhsach} anThongKe
                    menu={menu}
                    user={user}
                    setOpenModalChiTiet={setOpenModalChiTiet}
                />
            </Col>
        </Row>
        <Row gutter={8}>
            <Col span="24">
                <div className="card card-primary">
                    <Row>
                        <Col span="24">
                            <Space className="float-right" style={{ marginBottom: 8, padding: '0 8px', fontSize: '12px', fontStyle: "italic", fontFamily: '"Times New Roman", Times, serif' }}>
                                <span style={{ fontWeight: 600 }}>Chú thích nút Xem:</span>
                                <Space size={4}>
                                    <span className="hrm-btn hrm-btn-sm btn-primary" style={{ width: 16, height: 16, display: 'inline-block', borderRadius: 3 }} />
                                    <span>Chưa ý kiến</span>
                                </Space>
                                <Space size={4}>
                                    <span className="hrm-btn hrm-btn-sm btn-success" style={{ width: 16, height: 16, display: 'inline-block', borderRadius: 3 }} />
                                    <span>Đã ý kiến</span>
                                </Space>
                            </Space>
                            <Table
                                loading={isLoadingTable}
                                locale={{ emptyText: "Không có dữ liệu" }}
                                dataSource={data}
                                pagination={false}
                                sticky
                                scroll={{ x: 1200 }}
                            >
                                <Column title="Tên nhân viên" dataIndex="hoTen" key="hoTen" width="200px" fixed/>
                                <Column title="Chức vụ" dataIndex="tenChucVu" key="tenChucVu" fixed />
                                <ColumnGroup title="Cá nhân tự xếp loại" key ="canhan">
                                    <Column title="Tổng điểm" dataIndex="tuDanhGia" key="tuDanhGia" align="center" />
                                    <Column title="Xếp loại" dataIndex="tuDanhGia" key="tuDanhGiaXL" align="center" render={(value: any, record: any) => {
                                        return record.tuDanhGia != null ? getXepLoaiByDiemDanhGia(record.tuDanhGia, record.tuDanhGiaCM) : "";
                                    }} />
                                </ColumnGroup>
                                <ColumnGroup title="Xếp loại của LĐ phòng nghiệp vụ" key="ldpnv">
                                    <Column title="Tổng điểm" dataIndex="lanhDaoPhong" key="lanhDaoPhong" align="center" />
                                    <Column title="Xếp loại" dataIndex="lanhDaoPhong" key="lanhDaoPhongXL" align="center" render={(value: any, record: any) => {
                                        return record.lanhDaoPhong != null ? getXepLoaiByDiemDanhGia(record.lanhDaoPhong, record.lanhDaoPhongCM) : "";
                                    }} />
                                </ColumnGroup>
                                <ColumnGroup title="Ý kiến của Phó Giám đốc" key="pgd">
                                    <Column title="Tổng điểm" dataIndex="lanhDaoPhuTrach" key="lanhDaoPhuTrach" align="center" />
                                    <Column title="Xếp loại" dataIndex="lanhDaoPhuTrach" key="lanhDaoPhuTrachXL" align="center" render={(value: any, record: any) => {
                                        return record.lanhDaoPhuTrach != null ? getXepLoaiByDiemDanhGia(record.lanhDaoPhuTrach, record.lanhDaoPhuTrachCM) : "";
                                    }} />
                                </ColumnGroup>
                                <ColumnGroup title="Phê duyệt của Giám đốc" key ="gd">
                                    <Column title="Tổng điểm" dataIndex="diemDanhGia" key="diemDanhGia" align="center" />
                                    <Column title="Xếp loại" dataIndex="lanhDaoDonVi" key="lanhDaoDonVi" align="center"
                                        onCell={(record, rowIndex) => {
                                            return {
                                                onClick: (event) => {
                                                    event.stopPropagation();
                                                },
                                            };
                                        }}
                                        render={(value: any, record: any, index: number) => {
                                            return getXepLoai(record.lanhDaoDonVi)
                                        }}
                                    />
                                </ColumnGroup>
                                <Column title="Tổng số lỗi trong năm" dataIndex="tongSoLoi" key="tongSoLoi" align="center" />
                                <Column title="" dataIndex="action" key="action"
                                    fixed='right'
                                    onCell={(record, rowIndex) => {
                                        return {
                                            onClick: (event) => {
                                                event.stopPropagation();
                                            },
                                        };
                                    }}
                                    render={(value: any, record: any) => {
                                        return <Link key={record.idKPICaNhan} target="_blank" 
                                            rel="noopener noreferrer" className={"hrm-btn hrm-btn-sm " + layClassName(record)} to={Links.KPI.ChiTietKPI + "?id=" + record.idKPICaNhan}>Xem</Link>;
                                    }}
                                />
                            </Table>
                        </Col>
                    </Row>
                </div>
            </Col>
        </Row>
        <ModalTextForm
            dialogClassName={"modal-80wh"}
            show={openModalChiTiet.isShowModal}
            title={
                <>
                    Chi tiết kết quả tự đánh giá trong tháng
                    {openModalChiTiet.tenDonVi ? <span> - <strong>{openModalChiTiet.tenDonVi}</strong></span> : ''}
                </>
            }
            handleClose={() => setOpenModalChiTiet({ isShowModal: false, data: [] })}
            hideFooter
        >
            <Row>
                <Col span={24}>
                    <Table
                        loading={isLoadingTable}
                        locale={{ emptyText: "Không có dữ liệu" }}
                        dataSource={openModalChiTiet?.data}
                        pagination={false}
                        sticky
                        scroll={{ x: 1000 }}
                    >
                        <Column title="Tên nhân viên" dataIndex="hoTen" key="hoTen" width="200px" fixed />
                        <Column title={
                            <span style={{
                                fontWeight: 700,
                                color: '#1e40af'
                            }}>
                                Kết quả công việc
                            </span>
                        }>
                            <Column title="Trước" width="65px" dataIndex="truoc" key="truoc" align="center"
                                render={(_, record) => record.truoc} />
                            <Column title="Đúng" width="65px" dataIndex="dung" key="dung" align="center" render={(_, record) => record.dung} />
                            <Column title="Đang TH" width="65px" dataIndex="dangThucHien" key="dangThucHien" align="center" render={(_, record) => record.dangThucHien} />
                            <Column title="Trễ" width="65px" dataIndex="tre" key="tre" align="center" render={(_, record) => record.tre} />
                        </Column>
                        <Column title="Điểm cộng" width="74px" dataIndex="diemCong" key="diemCong" align="center"
                            render={(_, i) => i.lanhDaoPhuTrachDiemCong > 0 ? i.lanhDaoPhuTrachDiemCong : i.lanhDaoPhongDiemCong > 0 ? i.lanhDaoPhongDiemCong : i.tuDanhGiaDiemCong}
                        />
                        <Column title={
                            <span style={{
                                fontWeight: 700,
                                color: '#1e40af'
                            }}>
                                Điểm đánh giá
                            </span>
                        }>
                            <Column title="TĐG" width="65px" dataIndex="tuDanhGia" key="tuDanhGia" align="center" />
                            <Column title="LĐP" width="65px" dataIndex="lanhDaoPhong" key="lanhDaoPhong" align="center" />
                            <Column title="LĐPT" width="72px" dataIndex="lanhDaoPhuTrach" key="lanhDaoPhuTrach" align="center" />
                            <Column title="LĐĐV" width="74px" dataIndex="diemDanhGia" key="diemDanhGia" align="center" />
                        </Column>
                        <Column
                            title="Xếp loại"
                            width="74px"
                            key="xepLoai"
                            align="center"
                            render={(_, record) => record.xepLoai || record.xepLoaiDuKien}
                        />
                        <Column title="Lỗi năm" width="74px" dataIndex="tongSoLoi" key="tongSoLoi" align="center" />
                        <Column title="Thao tác" dataIndex="action" key="action" width="80px"
                            fixed='right' render={(value: any, record: any) => {
                                return <Space className="float-right">
                                    <Link target="_blank" style={{ padding: '2px 8px', fontSize: '13px', minWidth: '28px' }}
                                        rel="noopener noreferrer"
                                        className="hrm-btn hrm-btn-sm btn-primary" to={Links.KPI.ChiTietKPI + "?id=" + record.idKPICaNhan}>Xem</Link>
                                </Space>
                            }} />
                    </Table>
                </Col>
            </Row>
        </ModalTextForm>
    </section>
    );
};

export default YKienKPIPhoGiamDoc;
